/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: projects.page.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { type FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Pages from '@/shared/page';
import SEOMetadata from '@/constants/seo';
import App from '@/constants/app';
import Sections from '@/sections';
import Links from '@/constants/links';
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const ProjectsPage: FunctionComponent = () => {
  const { t } = useTranslation('projects');

  const headParams = {
    title: `${t('head.title')} | ${App.Name.toUpperCase()}`,
    description: SEOMetadata.description,
    ogType: 'website',
    structuredData: JSON.stringify({
      '@context': `${SEOMetadata.siteUrl}${Links.Public.PROJECTS}`,
      description: SEOMetadata.description
    })
  };

  return (
    <Pages.Fade headParams={headParams}>
      <Sections.Intros.Projects />
      <Sections.Projects />
      <Sections.Footer.BottomNavigation />
      <Sections.Footer.Copyright />
    </Pages.Fade>
  );
};

export default ProjectsPage;
